import React from 'react'
import { useTranslation } from 'react-i18next';

// Components
import PageLayout from '../components/PageLayout/PageLayout';
import BillingReportContent from '../components/ReportsContent/BillingReportContent';


const BillingReport = () => {
  const { t } = useTranslation();

  return (
    <PageLayout
      withHeader={true}
      title={t('MANUAL_BILLING')}
      crumbs={[
        { title: t('REPORTS'), to: '/reports' },
        { title: t('MANUAL_BILLING'), to: '' },
      ]}
    >
      <BillingReportContent />
    </PageLayout>
  )
}

export default BillingReport
